import get from 'lodash.get';

import { selectSearchParams } from '../../redux/router/selectors';
import { createDeepEqualSelector } from '../../redux/utils/selectors';

export const selectName = (_, props) => props.name;

export const selectIsVisible = createDeepEqualSelector([selectName, selectSearchParams], (name, searchParams) => {
  const modal = get(searchParams, 'modal', false);

  return modal === name;
});
